import {ProfileItem} from '~/app/core/common/models/profileItem';

export class ProfileItemInsert {
    customerId: number;
    userName: string;
    items: ProfileItem[] = [];
}
